<div routerLink="/">
  <img src="../../assets/img/schulio.png" />

  <h1>404</h1>
  <h2>NOT FOUND</h2>
</div>
